import { LitElement, html, css } from 'lit'

let SVG

customElements.define('k-logo', class extends LitElement{
    
    static properties = {
        h: {type: Boolean}
    }

    static styles = css`
        :host {
            display: inline-block;
            height: 2em;
        }

        svg {
            height: 100%;
        }

        :host-context(a:hover) svg {
            --green: var(--black);
            --blue: var(--black);
            --orange: var(--black);
        }
    `

    connectedCallback(){
        super.connectedCallback()
        if( !SVG && this.previousElementSibling?.tagName=='svg' ){
            SVG = this.previousElementSibling
            SVG.remove()
        }

        this.svg ||= SVG?.cloneNode(true)
    }

    render(){return html`
        ${this.svg}
    `}
    
    updated(changedProperties){
        if(changedProperties.has('h')){
            this.svg.setAttribute('viewBox', this.h ? '2080 681.5 910 1106.35' : SVG.getAttribute('viewBox'))
        }
    }

})

export default customElements.get('k-logo')